import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import PageSpinner from "../../components/global/pageSpinner"
import EditContainer from "../../components/global/editContainer"
import EditHeading from "../../components/global/editHeading"
import { MainContext } from "../../controllers/main"
import { ChallengesContext } from "../../controllers/challenges"
import { CircularProgress, Grow } from "@mui/material"

const ChallengeReport = () => {
  const { animation, setAnimation, showPadding } = useContext(MainContext)
  const { preChangesCurrentChallenge, getCurrentChallenge } =
    useContext(ChallengesContext)
  const navigate = useNavigate()
  const { challengeId } = useParams()

  // loading
  const [loading, setLoading] = useState<boolean>(true)

  // page error
  const [pageError, setPageError] = useState<boolean>(false)

  // fetch challenge if missing
  const fetchChallenge = async () => {
    if (!preChangesCurrentChallenge) {
      const noErrors = await getCurrentChallenge(challengeId)
      if (noErrors) {
        setLoading(false)
      } else {
        setPageError(true)
      }
    } else {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchChallenge()
  }, [])

  // iframe loading
  const [iframeLoading, setIframeLoading] = useState<boolean>(true)

  return loading ? (
    <PageSpinner
      showBackButton={pageError}
      backButtonOnClick={() => {
        navigate(
          window.location.pathname.slice(
            0,
            window.location.pathname.indexOf("/report")
          )
        )
      }}
    />
  ) : (
    <EditContainer>
      <EditHeading
        backButtonOnClick={() => {
          setAnimation(false)
          setTimeout(() => {
            navigate(
              window.location.pathname.slice(
                0,
                window.location.pathname.indexOf("/report")
              )
            )
          }, 300)
        }}
        title={preChangesCurrentChallenge.name + " / Report"}
        id={preChangesCurrentChallenge.id}
      />
      <Grow in={animation} timeout={350}>
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <iframe
            style={{
              width: "calc(100% - 280px)",
              height:
                showPadding === "yes"
                  ? "calc(100vh - 152px)"
                  : "calc(100vh - 134px)",
              overflow: "hidden",
              margin: showPadding === "yes" ? "16px" : 0,
              marginTop: 0,
              border: "none",
              borderRadius: 4,
            }}
            onLoad={() => {
              setIframeLoading(false)
            }}
            src={
              "https://lookerstudio.google.com/embed/reporting/e5fc0970-de70-48df-ad87-820202cb1350/page/ctQsC?params=" +
              encodeURI(
                JSON.stringify({
                  "ds59.challengeid": challengeId,
                  ChalleneLogChallengeId: challengeId,
                  "ds58.challengeid": challengeId,
                  ChallengeActionsLogged: challengeId,
                  ChallengeJoinID: challengeId,
                  "ds57.challengeid": challengeId,
                  "ds60.challengeid": challengeId,
                  DailyChallengeIncrement: challengeId,
                  DayOfWeek: challengeId,
                  GeographicDistribution: challengeId,
                  HourLogsDistribution: challengeId,
                  SDGChallenge: challengeId,
                })
              )
            }
          />
          {iframeLoading && (
            <CircularProgress style={{ position: "absolute" }} />
          )}
        </div>
      </Grow>
    </EditContainer>
  )
}

export default ChallengeReport
